var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.info.color,"small":_vm.small,"to":_vm.to,"dark":"","label":""}},[_vm._v(" "+_vm._s(_vm.info.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }